import React, { useState, useContext, createContext, lazy, Suspense } from 'react';

const Inner = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'./Inner.jsx'))

const AccordionContext = createContext();

export const useAccordionContext = () => {
    return useContext(AccordionContext);
};


const Accordion = ({children, openFirstPanel, showInfoBadges, showWarningBadges, showErrorBadges}) => {
    const [openPanel, setOpenPanel] = useState(openFirstPanel ? 0 : null);
    const [panelInfo, setPanelInfo] = useState({});
    const [panelWarnings, setPanelWarnings] = useState({});
    const [panelErrors, setPanelErrors] = useState({});
    const [firstRender, setFirstRender] = useState(true);

    const updatePanelInfo = (title, count) => {
        setPanelInfo(prev => ({
            ...prev,
            [title]: count,
        }));
    }

    const updatePanelWarnings = (title, count) => {
        setPanelWarnings(prev => ({
            ...prev,
            [title]: count,
        }));
    }

    const updatePanelErrors = (title, count) => {
        setPanelErrors(prev => ({
            ...prev,
            [title]: count,
        }));
    }

    const selectPanel = (e, index, isOpen) => {
        e.preventDefault();
        e.stopPropagation();
        setFirstRender(false);
        setOpenPanel(isOpen ? null : index)
    }

    const providerValues = {
        updatePanelInfo,
        updatePanelWarnings,
        updatePanelErrors,
        showInfoBadges,
        showWarningBadges,
        showErrorBadges,

        selectPanel,
        openPanel,
        panelInfo,
        panelWarnings,
        panelErrors,
        firstRender
    };

    return <div>
        <AccordionContext.Provider value={providerValues}>
            <Suspense fallback={null}>
                <Inner children={children} />
            </Suspense>
        </AccordionContext.Provider>
    </div>
}

export default Accordion;
